import apiClient from './client';

export const ActivityNotAllowedICDAxiosInstance = apiClient;